
import Vue from 'vue';
import Component from 'vue-class-component';

import HorizontalAlignLeft from "../resources/horizontalAlignLeft.vue";
import HorizontalAlignCenter from "../resources/horizontalAlignCenter.vue";
import HorizontalAlignRight from "../resources/horizontalAlignRight.vue";
import HorizontalAlignEven from "../resources/horizontalAlignEven.vue";
import VerticalAlignTop from "../resources/verticalAlignTop.vue";
import VerticalAlignCenter from "../resources/verticalAlignCenter.vue";
import VerticalAlignBottom from "../resources/verticalAlignBottom.vue";
import VerticalAlignEven from "../resources/verticalAlignEven.vue";

@Component({
    components: {
        HorizontalAlignLeft,
        HorizontalAlignCenter,
        HorizontalAlignRight,
        HorizontalAlignEven,
        VerticalAlignTop,
        VerticalAlignCenter,
        VerticalAlignBottom,
        VerticalAlignEven
    }
})
export default class AlignControl extends Vue
{
    private get color()
    {
        return this.$store.getters.userConfigColors.buttonColorCode;
    }

    align(direction: string, alignment: string)
    {
        this.$emit('align', direction, alignment);
    }
}
